// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10iGJ","footer":"styles_footer__3AO8s"};